import initHeadroom from './initHeadroom';
import customizeContent from './customizeContent';
import evidenceToggle from './evidenceToggle';
import readMore from './readMore';
import modal from './modal';
import videoPlayer from './videoPlayer';

initHeadroom();
evidenceToggle();
customizeContent();
readMore();
modal();
videoPlayer();
